<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <!--       <b-alert
        v-for="warning in current_warnings"
        :key="JSON.stringify(warning)"
        show
        variant="info"
      >
        {{ $t(warning) }}
      </b-alert> -->
      <b-form-group>
        <label>
          <b> {{ $t('table_chosen') }} </b>
        </label>
        <b-form-select v-model="table" :options="table_options" />
      </b-form-group>

      <b-card class="mb-3">
        <b-form-group>
          <label>
            <b> {{ $t('table_extension_mode') }} </b>
          </label>
          <b-form-radio-group v-model="keep_nonhistorypart_table">
            <b-form-radio :value="true">
              {{ $t('do_keep_nonhistorypart_table') }}
            </b-form-radio>

            <b-form-radio :value="false">
              {{ $t('donot_keep_nonhistorypart_table') }}
            </b-form-radio>
          </b-form-radio-group>
          <b-form-radio-group v-model="keep_historypart_table">
            <b-form-radio :value="true">
              {{ $t('do_keep_historypart_table') }}
            </b-form-radio>

            <b-form-radio :value="false">
              {{ $t('donot_keep_historypart_table') }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-card>
      <select-one-column
        :available_columns="all_columns"
        :value="period_column"
        @updated_value="period_column = $event"
      >
        <label>
          <b> {{ $t('periodicity_column') }} </b>
          <span
            v-c-tooltip="$t('periodicity_column_tooltip')"
            class="fas fa-question-circle"
          />
        </label>
      </select-one-column>

      <b-card class="mt-3" :header="$t('ref_period')">
        <b-form-checkbox v-model="ref_is_range" :value="true" class="mb-3">
          <b> {{ $t('all_ref_values') }} </b>
        </b-form-checkbox>

        <b-row v-if="ref_is_range">
          <b-col>
            <b-form-group>
              <label>
                <b> {{ $t('ref_period_start') }} </b>
              </label>
              <b-form-input v-model="start_ref" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>
                <b> {{ $t('ref_period_stop') }} </b>
              </label>
              <b-form-input v-model="stop_ref" type="number" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group v-else>
          <label>
            <b> {{ $t('period_values_list') }} </b>
          </label>
          <b-form-input v-model="ref_values_string" />
        </b-form-group>

        <b-form-group>
          <label>
            <b> {{ $t('suffix') }} </b>
          </label>
          <b-form-input v-model="ref_suffix" />
        </b-form-group>
      </b-card>

      <b-card class="mt-3" :header="$t('comp_period')">
        <b-form-checkbox v-model="comp_is_range" :value="true" class="mb-3">
          <b> {{ $t('all_comp_values') }} </b>
        </b-form-checkbox>

        <b-row v-if="comp_is_range">
          <b-col>
            <b-form-group>
              <label>
                <b> {{ $t('comp_period_start') }} </b>
              </label>
              <b-form-input v-model="start_comp" type="number" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>
                <b> {{ $t('comp_period_stop') }} </b>
              </label>
              <b-form-input v-model="stop_comp" type="number" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group v-else>
          <label>
            <b> {{ $t('period_values_list') }} </b>
          </label>
          <b-form-input v-model="comp_values_string" />
        </b-form-group>

        <b-form-group>
          <label>
            <b> {{ $t('suffix') }} </b>
          </label>
          <b-form-input v-model="comp_suffix" />
        </b-form-group>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "ref_period": "Reference period",
    "ref_period_start": "Reference period start",
    "ref_period_stop": "Reference period stop",
    "all_ref_values": "The reference period takes all intermediate values",

    "comp_period": "Comparison period",
    "comp_period_start": "Comparison period start",
    "comp_period_stop": "Comparison period stop",
    "all_comp_values": "The comparison period takes all intermediate values",

    "period_values_list": "List of period's values",
    "suffix": "Suffix added to created columns",

    "table_extension_mode": "Table extension mode",
    "do_keep_nonhistorypart_table": "Keep non history part of source table",
    "donot_keep_nonhistorypart_table": "Remove non history part of source table",
    "do_keep_historypart_table": "Keep history part of source table",
    "donot_keep_historypart_table": "Remove history part of source table"
  },
  "fr": {
    "ref_period": "Période de référence",
    "ref_period_start": "Début de la période de référence",
    "ref_period_stop": "Fin de la période de référence",
    "all_ref_values": "La période de référence prend toutes les valeurs intermédiaires",

    "comp_period": "Période de comparaison",
    "comp_period_start": "Début de la période de comparaison",
    "comp_period_stop": "Fin de la période de comparaison",
    "all_comp_values": "La période de comparaison prend toute les valeurs intermédiaires",

    "period_values_list": "Liste des valeurs de la période",
    "suffix": "Suffixe accolé aux colonnes crées",

    "table_extension_mode": "Mode d'extension de la table",
    "do_keep_nonhistorypart_table": "Conserver la partie non historique de la table source",
    "donot_keep_nonhistorypart_table": "Supprimer la partie non historique de la table source",
    "do_keep_historypart_table": "Conserver la partie historique de la table source",
    "donot_keep_historypart_table": "Supprimer la partie historique de la table source"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { BasicTableInfoEntity } from '@/components/object_model.js'
import { table_columns } from '@/api/subscriptions.js'

// import {
//   subscription_mixin,
//   brick_mixin,
//   metavariables_tracking_info_mixin,
//   brick_with_single_parent_mixin,
// } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import SelectOneColumn from './select_one_column.vue'

// *****************************************************************************

export default {
  name: 'BrickHistoryFeatureEngineering',
  components: {
    SelectOneColumn,
  },
  // mixins: [
  //   subscription_mixin,
  //   brick_mixin,
  //   metavariables_tracking_info_mixin,
  //   brick_with_single_parent_mixin,
  // ],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      table: -1,
      separate_extend_table: true,
      ref_is_range: true,
      comp_is_range: true,
      ref_suffix: '',
      comp_suffix: '',
      start_ref: 0,
      stop_ref: 0,
      start_comp: 0,
      stop_comp: 0,
      ref_values_string: '',
      comp_values_string: '',
      keep_historypart_table: false,
      keep_nonhistorypart_table: false,

      period_column: null,
      all_columns: [],
    }
  },
  computed: {
    // N.B PL : Why special case here and elsewhere not ?
    effective_entry_table_id() {
      let entry_table_id = this.cur_brick.parents_info || []
      let res = -1
      if (entry_table_id.length === 1) {
        res = entry_table_id[0].uid
      }
      return res
    },
    adapted_data() {
      let entry_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        entry_table_id = [parent_info_entity_type]
      }
      // N.B PL : Don't know why there is a special case here
      if (this.table === this.effective_entry_table_id) {
        entry_table_id = this.cur_brick.parents_info
      }

      let ref_values, comp_values

      if (this.ref_is_range) {
        ref_values = [this.start_ref, this.stop_ref]
      } else {
        ref_values = this.ref_values_string
      }

      if (this.comp_is_range) {
        comp_values = [this.start_comp, this.stop_comp]
      } else {
        comp_values = this.comp_values_string
      }

      let adapted = {
        uid: this.brick_id,
        parents_info: entry_table_id,
        keep_historypart_table: this.keep_historypart_table,
        keep_nonhistorypart_table: this.keep_nonhistorypart_table,
        period_column: this.period_column,
        ref_is_range: this.ref_is_range,
        comp_is_range: this.comp_is_range,
        ref_suffix: this.ref_suffix,
        comp_suffix: this.comp_suffix,
        ref_values: ref_values,
        comp_values: comp_values,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.table = this.effective_entry_table_id
        this.period_column = _.cloneDeep(new_val.period_column)
        this.keep_nonhistorypart_table = new_val.keep_nonhistorypart_table
        this.keep_historypart_table = new_val.keep_historypart_table
        this.ref_is_range = new_val.ref_is_range
        this.ref_suffix = new_val.ref_suffix
        if (new_val.ref_is_range) {
          this.start_ref = new_val.ref_values[0] || 0
          this.stop_ref = new_val.ref_values[1] || 0
        } else {
          this.ref_values_string = new_val.ref_values
        }

        this.comp_is_range = new_val.comp_is_range
        this.comp_suffix = new_val.comp_suffix
        if (new_val.comp_is_range) {
          this.start_comp = new_val.comp_values[0] || 0
          this.stop_comp = new_val.comp_values[1] || 0
        } else {
          this.comp_values_string = new_val.comp_values
        }
      },
    },

    table: {
      immediate: true,
      async handler(new_val, old_val) {
        if (new_val !== old_val) {
          this.all_columns =
            (await table_columns(this.project_id, new_val)).pipe_object || []
        }
      },
    },
  },
}
</script>
